import React, { useContext } from "react";
import classnames from "classnames";
import { MobileContext, LayoutContext } from "components/common";
import NavbarDesktop from "components/Navbar/NavbarDesktop";
import NavbarMobile from "components/Navbar/NavbarMobile";
import HeaderMobile from "components/Header/HeaderMobile";
import HeaderDesktop from "components/Header/HeaderDesktop";
import Drawer from "components/common/Drawer";
import PersistentModal from "components/common/Modals/PersistentModal";
import PersistentOverlay from "components/common/Overlay/PersistentOverlay";

const LayoutNoPadding = ({ children }) => {
  const { navWidth, navHeight } = useContext(LayoutContext);
  const { isMobile } = useContext(MobileContext);

  const renderDesktop = () => (
    <>
      <div
        className="fixed h-full z-10 overflow-y-scroll hide-y-scrollbar"
        style={{ width: navWidth, zIndex: 30 }}
      >
        <NavbarDesktop />
      </div>
      <div
        className="flex flex-col flex-1 w-full"
        style={{ marginLeft: navWidth }}
      >
        <div
          className="fixed shadow-header z-50"
          style={{
            height: navHeight,
            marginLeft: `-${navWidth}`,
            width: `calc(100% - ${navWidth}px)`,
          }}
        >
          <HeaderDesktop />
        </div>
        <div
          className={classnames(
            "w-full dashboard-max-w lg:mx-auto relative h-full",
          )}
          style={{ paddingTop: "4rem" }}
        >
          {children}
        </div>
      </div>
    </>
  );

  const renderMobile = () => (
    <>
      <div className="fixed z-50 w-full" style={{ height: navHeight }}>
        <HeaderMobile />
      </div>
      <div
        className={classnames(
          "flex-1 w-full dashboard-max-w lg:mx-auto relative",
        )}
        style={{ marginTop: "4rem", marginBottom: "5rem" }}
      >
        {children}
      </div>
      <NavbarMobile />
    </>
  );

  return (
    <div className="flex bg-transparent min-h-screen">
      {isMobile ? renderMobile() : renderDesktop()}
      <Drawer />
      <PersistentModal />
      <PersistentOverlay />
    </div>
  );
};

export default LayoutNoPadding;
